import React, { useContext, useEffect, useState } from "react";
import "./BudgetHead.css";
import Application from "../../../StateContext/Application.js";
import {Approved32,
  SendBack32,
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import BudgetHeadCreation from "./BudgetHeadCreation.js";
const BudgetHeadInwardList = () => {
  const operation = useContext(Application);
  const { GetBudgetHeadList, BudgetHeadApproval, Usermenu } = operation;

  const [head, setHead] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SelectedOptions, setSelectedOptions] = useState("Pending");
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  const totalPages =
    filteredBills?.length > 0
      ? Math.ceil(filteredBills.length / billsPerPage)
      : 1;
  //const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  console.log("currentbills", currentBills);
  const [remarkError, setRemarkError] = useState("");
  const [menuData, setMenuData] = useState({});
  const [editData, setEditData] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);

  useEffect(() => {
    BudgetHeadList();
  }, []);


   const BudgetHeadList = async () => {
  try {
    let res = await GetBudgetHeadList();
 
    const data = res?.result || [];
 
    // Latest added record first
    const latestFirst = [...data].reverse();
 
    setFilteredBills(latestFirst);
    setHead(latestFirst);
    setCurrentPage(1);
  } catch (err) {
    console.log(err);
  }
};
 


  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id],
    );
  };

  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(
        currentBills.map((bill) => bill.WorkOrderID || bill.HeadID),
      );
    } else {
      setSelectedBills([]);
    }
  };
  const closeRejectPanel = () => {
    setRejectpanelhide(0);
    setRemark("");
    setRemarkError("");
  };

  const approveorrejectSelected = async (condition, requiresRemark = false) => {
    if (selectedBills.length === 0) {
      alert("No Budget Head selected for approval!");
      return;
    }
    if (requiresRemark && !remark.trim()) {
      setRemarkError("Remark is required.");
      return;
    }

    console.log(selectedBills);
    setLoading(true);
    let shouldStart = window.confirm("Are you sure ???");

    if (!shouldStart) {
      alert(`Budget Head ${condition} Operation Cancelled !!!`);
      closeRejectPanel();
      return;
    }

    setLoading(true);
    try {
      // remark is now actually sent to the API
      let response = await BudgetHeadApproval(
        selectedBills,
        condition,
        remark.trim(),
      );

      if (response?.message) {
        alert(response.message);
      } else if (response?.error) {
        alert(response.error);
      }

      closeRejectPanel();
      setSelectedBills([]);
      await BudgetHeadList(); // refresh data instead of a full page reload
    } catch (error) {
      console.error("Error approving/rejecting Budget Head:", error);
      alert("An error occurred while processing the selected Budget Head(s).");
      closeRejectPanel();
    } finally {
      setLoading(false);
    }
  };
  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No Bill Selected !!!");
    }
  };
  useEffect(() => {
    const filtered = head.filter(
      (item) =>
        item.HeadName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.HeadDetails?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.CRC?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.HeadID?.toString().includes(searchTerm),
    );
    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [searchTerm, head]);

  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      setMenuData(res.Data);
    };
    getMenu();
  }, []);

  const isChecker =
    menuData?.Department_Name === "State Checker" &&
    menuData?.Role === "State Checker";

  const isMaker =
    menuData?.Department_Name === "State Maker" &&
    menuData?.Role === "State Maker";

  const handleEditProject = async () => {
    if (selectedBills.length !== 1) {
      alert("Please select one record.");
      return;
    }
    try {
      const selectedBill = filteredBills.find(
        (item) => item.ReleaseID === selectedBills[0],
      );
      setEditData(selectedBill);
      setOpenEdit(true);
      setShowEditForm(true);
    } catch (err) {
      console.log(err);
    }
  };

   const getPageNumbers = (currentPage, totalPages) => {
        const maxVisiblePages = 5;
 
        // 5 ya usse kam pages
        if (totalPages <= maxVisiblePages) {
            return Array.from(
                { length: totalPages },
                (_, index) => index + 1
            );
        }
 
        // Starting pages
        // 1 2 3 4 5 ... Last
        if (currentPage <= 3) {
            return [1, 2, 3, 4, 5, "...", totalPages];
        }
 
        // Last pages
        // ... 16 17 18 19 20
        if (currentPage >= totalPages - 2) {
            return [
                "...",
                totalPages - 4,
                totalPages - 3,
                totalPages - 2,
                totalPages - 1,
                totalPages
            ];
        }
 
        // Middle pages
        // ... 4 5 6 7 8 ... 20
        return [
            "...",
            currentPage - 2,
            currentPage - 1,
            currentPage,
            currentPage + 1,
            currentPage + 2,
            "...",
            totalPages
        ];
    };
 

 const headerStyle = {
    //28/10

        fontSize: "12px",
        fontWeight: "700",
        textAlign: "center",
        padding: "8px 10px",
        borderRight: "1px solid #d4ddef",
        borderBottom: "1px solid #d4ddef",
        whiteSpace: "nowrap"
    };





  return (
    <>
      <div
        className="col-12"
        style={{
          backgroundColor: "white",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
          //29/10
           padding: "15px 20px",       
           boxSizing: "border-box",    
        }}
      >
         <div style={{ width: "100%" }}>
          <div
           style={{
    width: "100%",
    background: openEdit ? "#FFFFFF" : "#EEF2F7",  
    border: "1px solid #dfe5ee",
    borderRadius: "10px",
    padding: "15px 20px 20px",
    boxSizing: "border-box",
  }}
          >

              <div
          //29/10
            // className="col-12 px-4 mb-4 mt-1"
          style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "15px",
  }}
          >
            <h5 className="my-auto fw-bold">
              {/* <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' /> */}
             <img
    src="/Budger Head Management 32 Size.png"
    alt="img"
    style={{
      width: "25px",
      height: "25px",
      filter: "brightness(0)",
      marginRight:"10px"
    }}
  />
              <span className="my-auto">Budget Head Inward List</span>
            </h5>

            <div
              style={{
                position: "relative",
                width: "250px",
                marginRight: "10px",
              }}
            >
              <img
                src="/Search32.png"
                alt="Search Icon"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  width: "16px",
                  height: "16px",
                  opacity: 0.6,
                }}
              />
              <input
                type="text"
                placeholder="Search Here"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
                style={{
                  width: "100%",
                  padding: "8px 12px 8px 32px", // left padding makes space for icon
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  fontSize: "14px",
                  color: "#333",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  outline: "none",
                }}
              />
            </div>
          </div>

          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255, 255, 255, 0.7)",
                backdropFilter: "blur(4px)",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  border: "6px solid #f3f3f3",
                  borderTop: "6px solid #007bff",
                  borderRadius: "50%",
                  width: "60px",
                  height: "60px",
                  animation: "spin 1s linear infinite",
                }}
              />
              <style>
                {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
              </style>
            </div>
          )}
          {/* ===================== LIST PAGE ===================== */}
          {!openEdit && (
            <>
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "white",
                  padding: " 20px 40px 5px 40px",
                  bottom:"1px solid #e4e8ec",
                  boxShadow: "0px  3px 8px rgba(0,0,0,0.12)",
                  borderRadius: "10px",
                  width: "100%",
                  maxWidth: "100%",
                  overflowX: "scroll",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  // style={{ background: "#2C78DB", overflowX: "scroll" }}
                  style={{
    width: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    border: "1px solid #dfe5ef",            
    borderRadius: "8px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.12)", 
    boxSizing: "border-box",
  }}
                >
                  {SelectedOptions === "Pending" && (
                    <table
                      className="m-0 p-0"
  style={{
    width: "100%",
    minWidth: "950px",
    borderCollapse: "separate",   
    borderSpacing: 0,
    backgroundColor: "#ffffff",
  }}
                    >
                      <thead style={{borderRadius:"4px 4px 0 0",overflow:"hidden"}}>
                        <tr
                          // style={{
                          //   color: "white",
                          //   border: "none",
                          //   height: "3rem",
                          //   fontSize: "12px",
                          // }}
                           style={{
                              //28/10
                                backgroundColor: "#2D79D9",
                                color: "white",
                                border: "none",
                                height: "34px",
                                fontSize: "12px",
                                fontWeight: "600",
                                textAlign: "center",
                                whiteSpace: "nowrap"
                            }}
                        >
                           <th style={{ minWidth: "50px", padding: "8px" }}>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                selectedBills.length === currentBills.length
                              }
                              className="my-auto"
                              style={{ height: "1rem", width: "1rem" }}
                            />
                          </th>
                          <th style={{ padding: "10px" }}>Sr.No</th>
                         
                         
                          <th style={{   
                                                    fontSize: "12px",
                                                    fontWeight: "700",
                                                    textAlign: "center",
                                                    padding: "8px 10px",
                                                    borderRight: "1px solid #d4ddef",
                                                    borderBottom: "1px solid #d4ddef",
                                                    whiteSpace: "nowrap"
                                                }}
                              >Head ID</th>
                          <th style={headerStyle}>Head Name</th>
                          <th style={headerStyle}>Head Details</th>
                          <th style={headerStyle}>CRC</th>
                          <th style={headerStyle}>Creation Date</th>
                          {isMaker && (
                            <th style={headerStyle}>Remark</th>
                          )}
                           {isMaker && (
                            <th style={{ padding: "10px" }}>Action</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {currentBills.length <= 0 ? (
                          <tr>
                            <td
                              colSpan="12"
                              style={{
                                textAlign: "center",
                                padding: "15px 10px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        ) : (
                          currentBills?.map((budgethead, index) => {
                            const bgColor =
                              index % 2 === 0 ? "#ffffff" : "#f4f6fb";
                            return (
                              <tr
                                style={{
                                  backgroundColor: bgColor,
                                  fontSize: "12px",
                                  fontWeight: "500",
                                }}
                                key={budgethead.HeadID ?? index}
                              >
                                 <td style={{ textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    className="my-auto"
                                    style={{ height: "1rem", width: "1rem" }}
                                    checked={selectedBills.includes(
                                      budgethead.HeadID,
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(budgethead.HeadID)
                                    }
                                  />
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  {indexOfFirstBill + index + 1}
                                </td>
                               

                               
                                <td style={{ padding: "10px" , color: "rgb(82, 149, 201)",textAlign:"center"}}>
                                  {budgethead.HeadID}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {budgethead.HeadName}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {budgethead.HeadDetails}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {budgethead.CRC}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {budgethead.Date?.split("T")[0].replace(" ")}
                                </td>
                                {isMaker && (
                                  <td style={{ padding: "10px" }}>
                                    {budgethead.Remark || "-"}
                                  </td>
                                )}
                                 {isMaker && (
                                  <td
                                    style={{
                                      padding: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <button
                                      onClick={() => {
                                        setEditData(budgethead);
                                        setOpenEdit(true);
                                      }}
                                      disabled={
                                        !selectedBills.includes(
                                          budgethead.HeadID,
                                        ) || loading
                                      }
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px",
                                        margin: "auto",
                                        padding: "6px 12px",
                                        background: selectedBills.includes(
                                          budgethead.HeadID,
                                        )
                                          ? "#0D6EFD"
                                          : "rgba(141,141,141,0.97)",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        cursor:
                                          selectedBills.includes(
                                            budgethead.HeadID,
                                          ) && !loading
                                            ? "pointer"
                                            : "not-allowed",
                                      }}
                                    >
                                      <img
                                        src={Edit32WHITE}
                                        alt="Edit"
                                        style={{
                                          width: "14px",
                                          height: "14px",
                                        }}
                                      />
                                      Edit
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="col-12 mt-3">
                  <div className="row">
                    <div
                      className="col-6 text-start"
                      style={{ display: "flex", justifyContent: "left" }}
                    >
                      <button
                        onClick={() =>
                          approveorrejectSelected("Approved", false)
                        }
                        disabled={selectedBills.length <= 0 ? true : loading}
                        className="ms-0"
                       
                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "6px",
 
                                            margin: "12px",
                                            padding: "7px 14px",
 
                                            minWidth: "150px",
                                            height: "36px",
 
                                            fontSize: "12px",
                                            fontWeight: "600",
 
                                            backgroundColor:
                                                selectedBills.length <= 0
                                                    ? "#f3eeee"
                                                    : "#39B54A",
 
                                            color: selectedBills.length > 0 ? "#ffffff" : "#01B574",
 
                                            border: "1px solid #39B54A",
                                            borderRadius: "6px",
 
                                            boxShadow:
                                                selectedBills.length <= 0
                                                    ? "none"
                                                    : "0 2px 5px rgba(57,181,74,0.20)",
 
                                            cursor:
                                                selectedBills.length <= 0 || loading
                                                    ? "not-allowed"
                                                    : "pointer",
 
                                            opacity:
                                                selectedBills.length <= 0 ? 0.7 : 1
                                        }}
 
                      >
                        <img
                                            src={Approved32}
                                            alt="Approve"
                                            style={{
                                                width: '18px',
                                                height: '18px'
                                            }}
                                        />
 {" "}
                        {loading ? "Processing..." : "Approve Selected"}
                      </button>

                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(2)}
                          disabled={selectedBills.length <= 0 ? true : loading}
                           style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "6px",
 
                                            margin: "12px",
                                            padding: "7px 14px",
 
                                            minWidth: "150px",
                                            height: "36px",
 
                                            fontSize: "12px",
                                            fontWeight: "600",
 
                                            backgroundColor:
                                                selectedBills.length <= 0
                                                    ? "#f3eeee"
                                                    : "#C1272D",
 
                                            color: selectedBills.length > 0 ? "#ffffff" : "red",
 
                                            border: "1px solid #ff6b81",
                                            borderRadius: "6px",
 
                                            boxShadow:
                                                selectedBills.length <= 0
                                                    ? "none"
                                                    : "0 2px 5px rgba(193,39,45,0.18)",
 
                                            cursor:
                                                selectedBills.length <= 0 || loading
                                                    ? "not-allowed"
                                                    : "pointer",
 
                                            opacity:
                                                selectedBills.length <= 0 ? 0.7 : 1
                                        }}
 
                        >
                         <img
                                            src={DeleteRed32}
                                            alt="Reject"
                                            style={{
                                                width: '18px',
                                                height: '18px',
                                                filter: selectedBills.length > 0
                                                    ? 'brightness(0) invert(1)'
                                                    : 'none'
                                            }}
                                        />{" "}
                          {loading ? "Processing..." : "Reject Selected"}
                        </button>
                      )}
                      {/* Send Back Button - Checker Only, opens modal id=3 */}
                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(3)}
                          disabled={selectedBills.length <= 0 || loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                           backgroundColor:
                        selectedBills.length <= 0
                          ? "#f3eeee"
                          : "blue",
                      border: "1px solid blue",
                      color:
                        selectedBills.length > 0
                          ? "white"
                          : "blue", whiteSpace: 'nowrap',
                            borderRadius: "8px",
                            // border: "none",
                            cursor:
                              selectedBills.length <= 0 || loading
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          <img
                      src={SendBack32}
                      alt="Send Back"
                      style={{
                        width: "18px",
                        height: "18px",
                        flexShrink: 0,
                        filter: selectedBills.length > 0
                          ? "brightness(0) invert(1)"
                          : "invert(28%) sepia(99%) saturate(7486%) hue-rotate(230deg) brightness(89%) contrast(128%)",
                      }}
                    />{" "}
                          {loading ? "Processing..." : "Send Back Selected"}
                        </button>
                      )}

                      {/* <button
                                        onClick={() => rejectSendbackbeforecheckup(3)} disabled={selectedBills.length <= 0 ? true : loading}
                                        style={{
                                            display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                            background: selectedBills.length <= 0 ? (
                                                'rgba(141, 141, 141, 0.97)'
                                            ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'), color: 'white', borderRadius: '8px',
                                            cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                        }}
                                    ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
                                    </button> */}
                    </div>
                      

                      <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginTop: "0px",
                                            marginBottom: "0px",
                                            paddingBottom: "0px",
                                            padding: "10px 5px",
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        {/* Showing Entries */}
                                        <div
                                            style={{
                                                fontSize: "13px",
                                                color: "#333",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Showing{" "}
                                            {filteredBills?.length === 0
                                                ? 0
                                                : indexOfFirstBill + 1}{" "}
                                            to{" "}
                                            {Math.min(
                                                indexOfLastBill,
                                                filteredBills?.length || 0
                                            )}{" "}
                                            of {filteredBills?.length || 0} entries
                                        </div>
 
                                        {/* Pagination Controls */}
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "18px",
                                            }}
                                        >
 
                                            {/* Previous */}
                                            <button
                                                onClick={() =>
                                                    setCurrentPage((prev) =>
                                                        Math.max(prev - 1, 1)
                                                    )
                                                }
                                                disabled={currentPage === 1}
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    color:
                                                        currentPage === 1
                                                            ? "#999"
                                                            : "#2ea4e7",
                                                    cursor:
                                                        currentPage === 1
                                                            ? "not-allowed"
                                                            : "pointer",
                                                    fontSize: "13px",
                                                    padding: 0,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    opacity:
                                                        currentPage === 1 ? 0.5 : 1,
                                                }}
                                            >
                                                <span style={{ fontSize: "20px" }}>‹</span>
                                                Previous
                                            </button>
 
                                            {/* Page Numbers */}
                                            {/* Page Numbers */}
 
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "20px",
                                                }}
                                            >
                                                {getPageNumbers(
                                                    currentPage,
                                                    totalPages
                                                ).map((pageNumber, index) => {
 
                                                    // Dots
                                                    if (pageNumber === "...") {
                                                        return (
                                                            <span
                                                                key={`ellipsis-${index}`}
                                                                style={{
                                                                    fontSize: "13px",
                                                                    color: "#444",
                                                                }}
                                                            >
                                                                ...
                                                            </span>
                                                        );
                                                    }
 
                                                    // Page Number
                                                    return (
                                                        <button
                                                            key={pageNumber}
                                                            onClick={() =>
                                                                setCurrentPage(pageNumber)
                                                            }
                                                            style={{
                                                                border: "none",
                                                                background: "transparent",
                                                                padding: 0,
                                                                color:
                                                                    currentPage === pageNumber
                                                                        ? "#2ea4e7"
                                                                        : "#444",
                                                                cursor: "pointer",
                                                                fontSize: "13px",
                                                                fontWeight:
                                                                    currentPage === pageNumber
                                                                        ? "600"
                                                                        : "400",
                                                                textDecoration:
                                                                    currentPage === pageNumber
                                                                        ? "underline"
                                                                        : "none",
                                                            }}
                                                        >
                                                            {pageNumber}
                                                        </button>
                                                    );
                                                })}
                                            </div>
 
                                            {/* Next */}
                                            <button
                                                onClick={() =>
                                                    setCurrentPage((prev) =>
                                                        Math.min(
                                                            prev + 1,
                                                            totalPages
                                                        )
                                                    )
                                                }
                                                disabled={
                                                    currentPage === totalPages ||
                                                    totalPages === 0
                                                }
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    color:
                                                        currentPage === totalPages ||
                                                            totalPages === 0
                                                            ? "#999"
                                                            : "#2ea4e7",
                                                    cursor:
                                                        currentPage === totalPages ||
                                                            totalPages === 0
                                                            ? "not-allowed"
                                                            : "pointer",
                                                    fontSize: "13px",
                                                    padding: 0,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    opacity:
                                                        currentPage === totalPages ||
                                                            totalPages === 0
                                                            ? 0.5
                                                            : 1,
                                                }}
                                            >
                                                Next
                                                <span style={{ fontSize: "20px" }}>›</span>
                                            </button>
 
                                        </div>
                                    </div>


                  </div>
                </div>
              </div>
            </>
          )}
          {/* ===================== REJECT MODAL ===================== */}
          {rejectPanelhide === 2 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label className="fw-bold">
                        Remark <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-8">
                      <textarea
                        placeholder="Enter Remark"
                        value={remark}
                        onChange={(e) => {
                          setRemark(e.target.value);
                          if (e.target.value.trim()) setRemarkError("");
                        }}
                        style={{ width: "100%", minHeight: "80px" }}
                      />
                      {remarkError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {remarkError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          type="button"
                          disabled={!remark.trim() || loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background: !remark.trim()
                              ? "rgba(141,141,141,0.97)"
                              : "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            color: "#fff",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                            border: "none",
                            borderRadius: "6px",
                            cursor:
                              !remark.trim() || loading
                                ? "not-allowed"
                                : "pointer",
                          }}
                          onClick={() =>
                            approveorrejectSelected("Rejected", true)
                          }
                        >
                          <img src={submit} style={{ width: "15px" }} /> Reject
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            color: "#fff",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                          }}
                          onClick={closeRejectPanel}
                        >
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* ===================== SEND BACK MODAL ===================== */}
          {rejectPanelhide === 3 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label className="fw-bold">
                        Remark <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-8">
                      <textarea
                        placeholder="Enter Remark"
                        value={remark}
                        onChange={(e) => {
                          setRemark(e.target.value);
                          if (e.target.value.trim()) setRemarkError("");
                        }}
                        style={{ width: "100%", minHeight: "80px" }}
                      />
                      {remarkError && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {remarkError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          type="button"
                          disabled={!remark.trim() || loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor:
                        selectedBills.length <= 0
                          ? "#f3eeee"
                          : "blue",
                      border: "1px solid blue",
                      color:
                        selectedBills.length > 0
                          ? "white"
                          : "blue", whiteSpace: 'nowrap',
                            height: "2rem",
                            fontSize: "16px",
                            border: "none",
                            borderRadius: "6px",
                            cursor:
                              !remark.trim() || loading
                                ? "not-allowed"
                                : "pointer",
                          }}
                          onClick={() =>
                            approveorrejectSelected("SendBack", true)
                          }
                        >
                          <img
                      src={SendBack32}
                      alt="Send Back"
                      style={{
                        width: "18px",
                        height: "18px",
                        flexShrink: 0,
                        filter: selectedBills.length > 0
                          ? "brightness(0) invert(1)"
                          : "invert(28%) sepia(99%) saturate(7486%) hue-rotate(230deg) brightness(89%) contrast(128%)",
                      }}
                    /> Send
                          Back
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            color: "#fff",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                          }}
                          onClick={closeRejectPanel}
                        >
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* ===================== EDIT PAGE ===================== */}
          {openEdit && (
            <div style={{ width: "100%" }}>
              {" "}
              {/* Top bar with Back button */}{" "}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "15px",
                }}
              >
                {" "}
                <button
                  onClick={() => {
                    setOpenEdit(false);
                    setEditData(null);
                  }}
                  style={{
                    background: "#0d6efd",
                    color: "#fff",
                    border: "none",
                    padding: "10px 18px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  {" "}
                  ← Back{" "}
                </button>{" "}
              </div>{" "}
              {/* Edit Form */}{" "}
              <BudgetHeadCreation
                isEdit={true}
                projectDatainward={editData}
                onSuccess={() => {
                  setOpenEdit(false);
                  setEditData(null);
                  BudgetHeadList();
                  setSelectedBills([]);
                }}
                onCancel={() => {
                  setOpenEdit(false);
                  setEditData(null);
                }}
              />{" "}
            </div>
          )}
        </div>
      </div></div>

      {/* {

                rejectPanelhide === 2 &&

                <div className='col-12 RejectPanelContainer'>
                    <div className="Rejectpanel">
                        <form action="">

                            <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3">
                                        <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-8">
                                        <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="col-12 ms-auto my-4">
                            <div className="row">
                                {/* <div className="col-3"></div> */}
      {/* <div className="col-9 m-auto">
                                    <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            }

            {
                rejectPanelhide === 3 &&

                <div className='col-12 RejectPanelContainer'>
                    <div className="Rejectpanel">
                        <form action="">

                            <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3">
                                        <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-8">
                                        <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                        </form>
                        <div className="col-12 ms-auto my-4">
                            <div className="row">
                                {/* <div className="col-3"></div> */}
      {/* <div className="col-9 m-auto">
                                    <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
                                        <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
    </>
  );
};

export default BudgetHeadInwardList;
